import { render } from "./enrolment-review-form.vue?vue&type=template&id=ecf86cb0&ts=true"
import script from "./enrolment-review-form.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-review-form.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__